export const CANCEL_NFT_SALE_TRACKER = `
import AFLNFT from 0xAFLContracts
import AFLMarketplaceV2 from 0xAFLContracts
import AflListingTrackerMarketplace from 0xAflListingTrackerMarketplace

/// Atomically delists an NFT from AFLMarketplaceV2 and removes it from AflListingTrackerMarketplace.
/// Steps:
///   1. Withdraws the NFT from the SaleCollection (delist from marketplace)
///   2. Deposits it back into the AFLNFT Collection
///   3. Removes the listing from AflListingTrackerMarketplace
///      (removeListing validates the NFT is gone from SaleCollection — step 1 ensures this)
transaction(tokenID: UInt64) {
  let collectionRef: &AFLNFT.Collection
  let saleRef: auth(AFLMarketplaceV2.Owner) &AFLMarketplaceV2.SaleCollection
  let trackerUpdater: &{AflListingTrackerMarketplace.UpdaterPublic}

  prepare(acct: auth(BorrowValue, AFLMarketplaceV2.Owner) &Account) {
    self.collectionRef = acct.storage
      .borrow<&AFLNFT.Collection>(from: /storage/AFLNFTCollection)
      ?? panic("Could not borrow AFLNFT collection")

    self.saleRef = acct.storage
      .borrow<auth(AFLMarketplaceV2.Owner) &AFLMarketplaceV2.SaleCollection>(
        from: /storage/AFLSaleCollectionV2
      )
      ?? panic("Could not borrow AFLMarketplaceV2 SaleCollection")

    let trackerAccount = getAccount(0xAflListingTrackerMarketplace)
    self.trackerUpdater = trackerAccount
      .capabilities
      .borrow<&{AflListingTrackerMarketplace.UpdaterPublic}>(
        AflListingTrackerMarketplace.UpdaterPublicPath
      )
      ?? panic("Could not borrow AflListingTrackerMarketplace Updater")
  }

  execute {
    // Step 1 & 2: delist from marketplace, return NFT to collection.
    let token <- self.saleRef.withdraw(tokenID: tokenID)
    self.collectionRef.deposit(token: <-token)

    // Step 3: remove from tracker.
    // The SaleCollection no longer holds the NFT so removeListing validation passes.
    self.trackerUpdater.removeListing(
      nftId: tokenID,
      saleCollectionRef: self.saleRef
    )
  }
}
`
